import useCustomTheme from '../hooks/theme-hook';
import { StylesHelper } from '../models/helpers/stylesHelper';

const airportEntryBackgroundColor = '#d8eaf7';
const airportEntryBorderColor = '#c5ddef';
const airportEntryAccentColor = '#1f78c8';
const airportEntryTitleColor = '#102334';
const airportEntrySubtitleColor = '#0a4f84';
const airportEntryBadgeBackgroundColor = '#ffffff';

const useMissionsListStyles = () => {
  const theme = useCustomTheme();

  let mapControl = {
    container: {
      backgroundColor: theme.background.primaryLight,
      justifyContent: 'flex-start' as any,
    },
    title: {
      flexDirection: 'row' as any,
      alignItems: 'center' as any,
    },
    subSession: {
      flexDirection: 'row' as any,
      alignItems: 'center' as any,
      ...StylesHelper.padding(8, 12, 12, 8),
      color: theme.text.titleDark,
      fontWeight: '600' as any,
      borderBottomWidth: 1,
      borderColor: theme.borderColorLight,
    },
    list: {
      filter: {
        container: {
          display: 'flex' as any,
          flexDirection: 'row' as any,
          gap: 8,
        },
        text: {
          color: theme.text.sea,
          fontSize: 12,
          fontWeight: '500' as any,
        },
        icon: {
          color: theme.text.sea,
          marginRight: 2,
        },
        link: {
          flexDirection: 'row' as any,
          alignItems: 'center' as any,
        },
        active: {
          textDecorationLine: 'underline' as any,
          textDecorationStyle: 'solid' as any,
          textDecorationColor: theme.text.sea,
          fontWeight: '600' as any,
        },
      },
      regular: {
        titleContainer: { paddingHorizontal: 16, paddingVertical: 16 },
        title: { color: theme.text.sea, fontSize: 12, fontWeight: '500' as any },
      },
      airportEntry: {
        container: {
          ...StylesHelper.padding(12),
          borderBottomWidth: 1,
          borderColor: airportEntryBorderColor,
          backgroundColor: airportEntryBackgroundColor,
          minHeight: 96,
          flexDirection: 'row' as any,
          alignItems: 'center' as any,
        },
        iconBase: {
          display: 'flex' as any,
          flexDirection: 'row' as any,
          alignItems: 'center' as any,
          justifyContent: 'center' as any,
          height: 48,
          width: 48,
          marginRight: 12,
          borderRadius: 24,
          overflow: 'hidden' as any,
          borderWidth: 1,
          borderColor: airportEntryBorderColor,
          backgroundColor: airportEntryBadgeBackgroundColor,
          flexShrink: 0,
        },
        icon: {
          color: airportEntryAccentColor,
        },
        iconImage: {
          width: '100%',
          height: '100%',
        },
        content: {
          flexGrow: 1,
          flexShrink: 1,
          marginRight: 8,
        },
        title: {
          color: airportEntryTitleColor,
          fontWeight: '600' as any,
          fontSize: 16,
          flexShrink: 1,
        },
        subtitle: {
          color: airportEntrySubtitleColor,
          fontWeight: '500' as any,
          fontSize: 12,
          marginTop: 4,
          flexShrink: 1,
        },
        meta: {
          flexDirection: 'row' as any,
          alignItems: 'center' as any,
          flexShrink: 0,
        },
        countBadge: {
          minWidth: 24,
          height: 24,
          borderRadius: 12,
          borderWidth: 1,
          borderColor: airportEntryBorderColor,
          alignItems: 'center' as any,
          justifyContent: 'center' as any,
          backgroundColor: airportEntryBadgeBackgroundColor,
          marginRight: 10,
        },
        countText: {
          color: airportEntryTitleColor,
          fontSize: 12,
          fontWeight: '700' as any,
        },
        chevron: {
          color: airportEntryTitleColor,
        },
      },
    },
  };

  return mapControl as typeof mapControl;
};

export default useMissionsListStyles;
